import React from "react";

import IconNewsletter from "../components/icons/Newsletter";
import Checklist from "../components/list/Checklist";
import NewsletterForm from "../components/newsletter/NewsletterForm";
import Newsletter from "../components/newsletter/Newsletter";

const SectionNewsletterSubscription = () => (
  <section className="border border-accent" data-type-mapping="newsletter">
    <Newsletter>
      <IconNewsletter />
      <h2 className="headline--6 uppercase text-primary py-4 text-center">
        Jetzt zum Newsletter anmelden!
      </h2>
      <Checklist
        list={[
          "Handverlesene Top-Schnäppchen",
          "Sonderaktionen & Spitzenpreise",
          "Direkt in Ihr Postfach",
        ]}
      />
      <div className="lg:flex lg:flex-col lg:items-center w-full pt-4 pb-2">
        <NewsletterForm />
      </div>
      <p className="text-primary py-2 text-left text-xxs lg:w-4/5">
        Ich möchte von Null-Leasing per E-Mail Angebote, Umfragen sowie Informationen über Produkte und Leistungen von Null-Leasing und der mobile.de GmbH erhalten (jederzeit widerrufbar).
      </p>
    </Newsletter>
  </section>
);

export default SectionNewsletterSubscription;
